import { useQuery } from '@tanstack/react-query'
import { ApiError, client } from '../client'
import { queryKeys } from '../keys'

// Manual types until API types are regenerated
export interface NotificationEventTypeInfo {
  event_type: string
  description: string
  group: string
  default_enabled: boolean
}

export interface NotificationPreference {
  event_type: string
  enabled: boolean
  updated_at: string | null
}

export interface NotificationPreferencesResponse {
  preferences: Array<NotificationPreference>
  total: number
}

export interface NotificationEventTypesResponse {
  event_types: Array<NotificationEventTypeInfo>
}

export function useNotificationPreferences() {
  return useQuery({
    queryKey: queryKeys.notifications.preferences(),
    queryFn: async () => {
      const response = await client.GET(
        '/api/v1/notifications/preferences' as never,
        {} as never,
      )
      const { data, error } = response as {
        data?: NotificationPreferencesResponse
        error?: { detail?: string }
      }
      if (error) {
        throw new ApiError(
          500,
          (error as { detail?: string }).detail ??
            'Failed to fetch notification preferences',
        )
      }
      return data as NotificationPreferencesResponse
    },
    staleTime: 5 * 60 * 1000,
  })
}

export function useNotificationEventTypes() {
  return useQuery({
    queryKey: queryKeys.notifications.eventTypes(),
    queryFn: async () => {
      const response = await client.GET(
        '/api/v1/notifications/event-types' as never,
        {} as never,
      )
      const { data, error } = response as {
        data?: NotificationEventTypesResponse
        error?: { detail?: string }
      }
      if (error) {
        throw new ApiError(
          500,
          (error as { detail?: string }).detail ??
            'Failed to fetch notification event types',
        )
      }
      return data as NotificationEventTypesResponse
    },
    staleTime: 30 * 60 * 1000,
  })
}
